<app-navbar>
    <h2>{{'LOGIN.REGISTER' | translate}}</h2>REGISTER_DATA
</app-navbar>

<div class="container">
    <div class="register-area">
        <h4 class="custom-section-title mb-10">{{'LOGIN.REGISTER_DATA' | translate}}</h4>
        <!--Register Form-->
        <form [formGroup]="frmSignup" (submit)="submit()" *ngIf="!formHasBeenSend">

            <div class="row">

                <!-- Account Title-->
                <div class="col-md-6 col-12 mb-2" *ngFor="let title of accountTitle">
                    <div class="form-check account-title mb-5 p-0">
                        <input type="radio"
                               class="w-100 h-100 position-absolute"
                               [ngModel]="'client'"
                               name="title"
                               #title='ngModel'
                               [value]="title"
                               (click)="titleSelect(title)"
                               required
                        >
                        <label class="form-check-label" *ngIf="title == 'client'">
                            {{'LOGIN.COMPANY' | translate}}
                        </label>
                        <label class="form-check-label" *ngIf="title == 'candidate'">
                            {{'LOGIN.CANDIDATE' | translate}}
                        </label>
                    </div>
                </div>
                <!--First Name-->
                <div class="col-md-6">
                    <div class="form-group">
                        <input type="text"
                                id="lastName"
                               formControlName="lastName"
                               class="form-control"
                               placeholder="{{'LOGIN.LAST_NAME' | translate}} {{'LOGIN.CONTACT_DETAILS' | translate}}"
                               required
                        >

                        <div class="mt-1" *ngIf="frmSignup.controls['lastName'].touched">
                               <span class="help-block" *ngIf="frmSignup.controls['lastName'].hasError('required')">
                        {{'VALIDATION.REQUIRED' | translate}}</span>
                        </div>
                        <div class="mt-1" *ngIf="frmSignup.controls['lastName'].touched">
                            <span class="help-block" *ngIf="frmSignup.controls['lastName'].hasError('pattern')">
                    {{'VALIDATION.ONLY_LETTERS' | translate}}</span>
                     </div>
                    </div>
                </div>
                <!--Last Name-->
                <div class="col-md-6">
                    <div class="form-group">
                        <input type="text"
                               formControlName="firstName"
                               id = 'firstName'
                               class="form-control"
                               placeholder="{{'LOGIN.FIRST_NAME' | translate}} {{'LOGIN.CONTACT_DETAILS' | translate}}"
                               required
                        >
                        <div class="mt-1" *ngIf="frmSignup.controls['firstName'].touched">
                               <span class="help-block" *ngIf="frmSignup.controls['firstName'].hasError('required')">
                    {{'VALIDATION.REQUIRED' | translate}}</span>
                        </div>
                        <div class="mt-1" *ngIf="frmSignup.controls['firstName'].touched">
                            <span class="help-block" *ngIf="frmSignup.controls['firstName'].hasError('pattern')">
                    {{'VALIDATION.ONLY_LETTERS' | translate}}</span>
                     </div>
                    </div>
                </div>
                <!--Email Address-->
                <div class="col-12">
                    <div class="form-group">
                        <input id="email"
                               formControlName="email"
                               type="email"
                               class="form-control"
                               placeholder="Email"
                               [ngClass]="frmSignup.controls['email'].invalid && frmSignup.controls['email'].touched ? 'is-invalid' : ''">

                        <div class="mt-1" *ngIf="frmSignup.controls['email'].touched">
                               <span class="help-block" *ngIf="frmSignup.controls['email'].hasError('required')">
                    {{'VALIDATION.REQUIRED' | translate}}</span>
                            <span class="help-block" *ngIf="frmSignup.controls['email'].hasError('pattern')">
                    Adresa de email nu este valida!</span>
                        </div>
                    </div>
                </div>
                <!--Password-->
                <div class="col-12">
                    <div class="form-group">

                        <input id="password"
                               formControlName="password"
                               type="password"
                               class="form-control"
                               placeholder="{{'LOGIN.PASSWORD' | translate}}"
                               [ngClass]="frmSignup.controls['password'].invalid && frmSignup.controls['password'].touched ? 'is-invalid' : ''">


                        <div class="mt-1" *ngIf="frmSignup.controls['password'].touched">
                        <span class="d-block"
                              [ngClass]="frmSignup.controls['password'].hasError('required') || frmSignup.controls['password'].hasError('minlength')  ? 'help-block' : 'success-block'">
                            <i class="{{frmSignup.controls['password'].hasError('required') || frmSignup.controls['password'].hasError('minlength') ? 'icofont-close-circled red-color' : 'icofont-check-circled green-color' }}"></i>
                            {{'VALIDATION.PASSWORD_MIN' | translate}}
                        </span>
                            <span class="d-block"
                                  [ngClass]="frmSignup.controls['password'].hasError('required') || frmSignup.controls['password'].hasError('hasNumber')  ? 'help-block' : 'success-block'">
                           <i class="{{frmSignup.controls['password'].hasError('required') || frmSignup.controls['password'].hasError('hasNumber') ? 'icofont-close-circled red-color' : 'icofont-check-circled green-color' }}"></i>
                            {{'VALIDATION.PASSWORD_NUMBER' | translate}}
                        </span>
                            <span class="d-block"
                                  [ngClass]="frmSignup.controls['password'].hasError('required') || frmSignup.controls['password'].hasError('hasCapitalCase')  ? 'help-block' : 'success-block'">
                            <i class="{{frmSignup.controls['password'].hasError('required') || frmSignup.controls['password'].hasError('hasCapitalCase') ? 'icofont-close-circled red-color' : 'icofont-check-circled green-color' }}"></i>
                            {{'VALIDATION.PASSWORD_UPPERCASE' | translate}}
                        </span>
                            <span class="d-block"
                                  [ngClass]="frmSignup.controls['password'].hasError('required') || frmSignup.controls['password'].hasError('hasSmallCase')  ? 'help-block' : 'success-block'">
                            <i class="{{frmSignup.controls['password'].hasError('required') || frmSignup.controls['password'].hasError('hasSmallCase') ? 'icofont-close-circled red-color' : 'icofont-check-circled green-color' }}"></i>
                            {{'VALIDATION.PASSWORD_LOWERCASE' | translate}}
                        </span>
                            <span class="d-block"
                                  [ngClass]="frmSignup.controls['password'].hasError('required') || frmSignup.controls['password'].hasError('hasSpecialCharacters') ? 'help-block' : 'success-block'">
                           <i class="{{frmSignup.controls['password'].hasError('required') || frmSignup.controls['password'].hasError('hasSpecialCharacters') ? 'icofont-close-circled red-color' : 'icofont-check-circled green-color' }}"></i>
                            {{'VALIDATION.PASSWRD_SPECIAL_CHARACTER' | translate}}
                        </span>
                        </div>
                    </div>
                </div>
                <!--Confirm Password-->
                <div class="col-12">
                    <div class="form-group">
                        <input id="confirmPassword"
                               formControlName="confirmPassword"
                               type="password"
                               placeholder="{{'LOGIN.PASSWORD_CONFIRM' | translate}}"
                               class="form-control"
                               [ngClass]="frmSignup.controls['confirmPassword'].invalid && frmSignup.controls['confirmPassword'].touched ? 'is-invalid' : ''">

                        <div class="mt-1" *ngIf="frmSignup.controls['confirmPassword'].touched">
                            <span class="help-block" *ngIf="frmSignup.controls['confirmPassword'].hasError('required')">{{'VALIDATION.REQUIRED' | translate}}</span>
                            <span class="help-block"
                                  *ngIf="frmSignup.controls['confirmPassword'].hasError('NoPassswordMatch')">{{'VALIDATION.PASSWORD_MATCH' | translate}}</span>
                        </div>
                    </div>
                </div>
                <!--Country-->
                <div class="col-md-12">
                    <div class="form-group">
                        <select formControlName="country"
                                class="form-control"
                                required
                                (change)=citiesReload($event)
                        >
                            <option [ngValue]="null" disabled>{{'DROPDOWN.COUNTRY' | translate}}</option>
                            <option *ngFor="let select of location">{{select.name}}</option>

                        </select>

                        <div class="mt-1" *ngIf="frmSignup.controls['country'].touched">
                               <span class="help-block" *ngIf="frmSignup.controls['country'].hasError('required')">
                    {{'VALIDATION.REQUIRED' | translate}}</span>
                        </div>
                    </div>
                </div>
                <!--City-->
                <div class="col-12">
                    <div class="form-group">
                        <select class="form-control"
                                formControlName="city"
                                name="city"
                                required
                        >
                            <option [ngValue]="null" disabled>{{'DROPDOWN.CITY' | translate}}</option>
                            <option *ngFor="let city of cities" value="{{city}}">{{city}}</option>
                        </select>

                        <div class="mt-1" *ngIf="frmSignup.controls['city'].touched">
                               <span class="help-block" *ngIf="frmSignup.controls['city'].hasError('required')">
                                   {{'VALIDATION.REQUIRED' | translate}}
                               </span>
                        </div>
                    </div>
                </div>
                <!--Address-->
                <div class="col-md-12">
                    <div class="form-group">
                        <input type="text"
                               formControlName="address"
                               class="form-control"
                               placeholder="{{'LOGIN.ADDRESS' | translate}}"
                        >
                    </div>
                </div>
                <!--Register Button-->
                <div class="col-12">
                    <app-form-message [success]="formResponse"
                                      [customSuccessMessage]="'Multumim pentru inregistrare! Te rugam sa apesi pe linkul din emailul de confirmare.'"
                                      [customErrorMessage]="emailExistError === true ? 'Acest email este folosit!' : 'Ceva nu a functionat. Te rugam sa mai incerci o data.'"
                                      *ngIf="formSent"></app-form-message>

                    <button type="submit" class="green-button w-100 border-0">
                        {{'LOGIN.SIGN_UP' | translate}}
                    </button>
                </div>
            </div>
        </form>
    </div>
</div>

<app-footer></app-footer>
